











































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'c-date-picker',
    filters: {
        dateFormat: function (value: string) {
            if (!value) return ''
            value = value.toString()
            const dateArr = value.split("-")
            const dateNewOrder = []
            for (let i = 2; i >= 0; i--) {
                if (dateArr[i]) {
                    dateNewOrder.push(dateArr[i])
                }
            }
        return dateNewOrder.join('.')
        }
    }
})

export default class CDatePicker extends Vue {
    @Prop({
        required: true,
    })
    private item!: any;

    @Prop({
        required: true,
    })
    private header!: any;

    @Prop({
        required: true,
        default: 'start'
    })
    private startEnd!: 'start' | 'end';

    @Prop({
        required: true,
    })
    private dateField!: string;

    @Prop({
        required: false,
        default: null,
    })
    private counterpartField!: string | null;

    @Prop({
        required: false,
        default: false,
    })
    private minYearFromHeader!: boolean;

    @Prop({
        required: false,
        default: false,
    })
    private allowEqualDates!: boolean;

    @Prop({
        required: false,
        default: false,
    })
    private highlightRange!: boolean;

    private get counterpartFieldName(): string {
        if (this.counterpartField) return this.counterpartField;
        return this.startEnd === 'end' ? 'beg_date' : 'end_date';
    }

    private dateInfoFn(ymd: string): string {
        if (!this.highlightRange || !this.item) return '';
        const begDate = this.startEnd === 'start' ? this.item[this.dateField] : this.item[this.counterpartFieldName];
        const endDate = this.startEnd === 'start' ? this.item[this.counterpartFieldName] : this.item[this.dateField];
        if (begDate && endDate && ymd >= begDate && ymd <= endDate) {
            return 'trip-range-day';
        }
        return '';
    }

    private mounted(): void {
        this.setCalendarBtnStyle('#7c9db3cc')
    }

    // ----------- Получение крайних дат -------------------
    private get minDate(): string {
        let minDate = ''
        if (this.header && this.header.year) {
            const year = `${this.header.year}-01-01`
            if (this.startEnd === 'end') {
                const begDate = this.item ? this.item[this.counterpartFieldName] : null;
                if (begDate) {
                    let minBoundDate = begDate
                    if (!this.allowEqualDates) {
                        const begDay = parseInt(minBoundDate.slice(-2));
                        const nextDay = begDay + 1;
                        minBoundDate = minBoundDate.slice(0, -2) + this.addZero(nextDay);
                    }
                    minDate = minBoundDate > year ? minBoundDate : year;
                }
            } else if (this.startEnd === 'start' && this.minYearFromHeader) {
                minDate = year
            }
        }
        return minDate
    }

    private get maxDate(): string {
        let maxDate = ''
        if (this.header && this.header.year) {
            const year = `${this.header.year}-12-31`
            if (this.startEnd === 'start') {
                maxDate = year
                const endDate = this.item ? this.item[this.counterpartFieldName] : null;
                if (endDate) {
                    let maxBoundDate = endDate
                    if (!this.allowEqualDates) {
                        const endDay = parseInt(maxBoundDate.slice(-2));
                        const prevDay = endDay - 1;
                        maxBoundDate = maxBoundDate.slice(0, -2) + this.addZero(prevDay);
                    }
                    maxDate = maxBoundDate < year ? maxBoundDate : year;
                }
            } else if (this.startEnd === 'end' && this.minYearFromHeader) {
                maxDate = year
            }
        }
        return maxDate
    }

    private addZero(number: number) {
        if (number < 10) return '0' + number;
        return '' + number;
    }


    private onDateInput(value: string): void {
        this.$set(this.item, this.dateField, value);
        this.$emit('input', value);
    }

    // ----------- Стилизация компонента -------------------
    private onOpenCalendar(): void {
        this.$nextTick(() => {
            this.setCalendarBackgroundColor('white')
        })
    }

    private setCalendarBackgroundColor(color: string): void {
        const calendar: HTMLElement | null = document.querySelector('.calc-forms-date-picker .b-calendar-grid')
        if (calendar) {
            calendar.style.backgroundColor = color;
        }
    }

    private setCalendarBtnStyle(color: string): void {
        const btnArr: HTMLElement[] = Array.from(document.querySelectorAll('.table-container .table .calc-forms-date-picker button.btn.btn-secondary'))
        if (btnArr) {
            btnArr.forEach((btn: HTMLElement, i: number) => {
                btn.style.setProperty("background-color", color, "important");
                btn.style.padding = '0 4px';
            })
        }
    }
}

